module.exports = __webpack_public_path__ + "img/paragraph.7b3d650e.svg";